module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"viewMore":"Se flere","viewSome":"Se noen","videos":"Videoer"},"en":{"viewMore":"View More","viewSome":"View Some","videos":"Videos"}}')
  delete Component.options._Ctor
}
